import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  selectedLanguage: BehaviorSubject<string> = new BehaviorSubject<string>('en');
  constructor() { }
}
